class BbaHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-bba-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-bba-dot]'));
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
    if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.timer = window.setInterval(() => this.show((this.index + 1) % this.slides.length), Number(this.dataset.interval) || 6000);
      this.addEventListener('mouseenter', () => window.clearInterval(this.timer));
    }
  }

  show(index) {
    this.index = index;
    this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
    this.dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
  }
}

class BbaProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.select(index)));
  }

  select(index) {
    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === index));
  }
}

if (!customElements.get('bba-hero')) customElements.define('bba-hero', BbaHero);
if (!customElements.get('bba-product-tabs')) customElements.define('bba-product-tabs', BbaProductTabs);
